import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Core2Config } from '../shared';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { HcMedicineHdrContainerModel } from '../../../../../models/aggregates/healthcare/medicine_hdr_container.model';

@Injectable({ providedIn: 'root' })
export class HcMedicineHdrService extends BaseApiTemplateService<HcMedicineHdrContainerModel> {
    readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + "medicine-hdrs";

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + 'medicine-hdrs' + '/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + 'medicine-hdrs' + '/backoffice-ep';
        this.httpClient = http;
    }
}